import type { FaireProductEntity } from "../../entity_types/product";

export const p_7tcncfve: FaireProductEntity = {
  token: "p_7tcncfve",
  type: "product",
  name: "Peppermint 100% Pure Therapeutic Grade Essential Oil 15mL",
  brandToken: "b_3t2zevr8",
  brandName: "ZAQ Skin + Body Care",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/2b5c8099805537e233c85af9498db9ad1d66025579537a7e814358dee1e33a41/1545860234.jpg",
  galleryImageUrls: [],
  priceDollars: 2.75,
  description:
    "The minty fresh aromas of peppermint will give you an extra energy boost to help you through your day. One of the oldest therapeutic grade essential oils in the aromatherapy toolbox, use its invigorating effects morning, afternoon and early evening. Aromatherapists also suggest using peppermint to help manage nausea, muscle pain, nerve pain, aches and indigestion. And, if you’re heading out camping, it’s a great bug repellent.\n\n",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:11.764Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
